import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge component that sends navigation menu items to native app
// and handles navigation when menu items are selected
export default class extends BridgeComponent {
  static component = "menu"

  static values = {
    items: Array, // Navigation items to display in native sidebar
    spaceGroup: String, // Current space group key
    spaceBranch: String, // Current space branch key
    spaceName: String, // Current space group name (human-readable)
    branchName: String, // Current space branch name (human-readable)
    userInitials: String, // Current user initials for avatar
    title: String, // Menu title (e.g., "ROI Tool", "Admin")
  }

  connect() {
    super.connect()

    console.log("[MenuBridge] connect()")
    console.log("[MenuBridge] enabled:", this.enabled)
    console.log("[MenuBridge] items:", this.itemsValue)

    // Send menu items to native app
    this.send(
      "connect",
      {
        title: this.titleValue,
        items: this.itemsValue,
        spaceGroup: this.spaceGroupValue,
        spaceBranch: this.spaceBranchValue,
        spaceName: this.spaceNameValue,
        branchName: this.branchNameValue,
        userInitials: this.userInitialsValue,
      },
      (response) => {
        console.log("[MenuBridge] received reply:", response)
        this.handleNavigation(response)
      },
    )
  }

  // Toggle the native sidebar - called when logo is pressed
  toggle() {
    console.log("[MenuBridge] toggle()")
    this.send("toggle", {}, (response) => {
      console.log("[MenuBridge] toggle reply:", response)
      if (response?.navigate) {
        this.handleNavigation(response)
      }
    })
  }

  // Handle navigation from native menu item selection
  handleNavigation(data) {
    if (!data?.navigate) return

    const path = data.navigate
    console.log("[MenuBridge] navigating to:", path)

    // Use Turbo to navigate
    if (window.Turbo) {
      window.Turbo.visit(path)
    } else {
      window.location.href = path
    }
  }

  // Update menu items dynamically (e.g., after permission changes)
  updateItems(items) {
    this.itemsValue = items
    this.send(
      "updateItems",
      {
        items: this.itemsValue,
      },
      () => {},
    )
  }
}
